import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AppSidebar from './AppSidebar';
import { Navbar } from './common/Catalyst/navbar';
import { SidebarLayout } from './common/Catalyst/sidebar-layout';
import WorkOrderList from './WorkOrderList';
import { WorkOrderKanbanBoard } from './workorder/WorkOrderKanbanBoard';
import { ViewSwitch, ListViewMode } from './violation/linear/ViewSwitch';

// 'list' is the grouped list (#603), laid out like violations; the board
// stays as the alternative. A saved 'table' predates the grouped list and
// means the same view.
type ViewMode = ListViewMode;

const VIEW_MODE_KEY = 'workOrderViewMode';

interface WorkOrderPageProps {
  currentPage: string;
}

const WorkOrderPage: React.FC<WorkOrderPageProps> = ({ currentPage }) => {
  const { hoaId, homeId } = useParams<{ hoaId?: string; homeId?: string }>();
  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    try {
      return localStorage.getItem(VIEW_MODE_KEY) === 'kanban' ? 'kanban' : 'list';
    } catch {
      return 'list';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(VIEW_MODE_KEY, viewMode);
    } catch {
      // Storage unavailable: the choice lasts for this page only.
    }
  }, [viewMode]);

  const switcher = <ViewSwitch value={viewMode} onChange={setViewMode} />;

  return (
    <SidebarLayout
      sidebar={<AppSidebar currentPage={currentPage} />}
      navbar={<Navbar>{/* Your navbar content */}</Navbar>}
      // Both views use the whole panel and scroll inside themselves; the
      // page never scrolls on desktop. Both run to the panel's edges, with
      // their toolbar as the top row (Linear's views); the board's
      // columns keep a gutter below it.
      fill
      flush
    >
      {/* No page heading: the sidebar already says where you are, and the
          view's own toolbar (the filter bar, or the bar over the board)
          carries the view switch. */}
      <div className="flex min-h-0 flex-1 flex-col">
        {viewMode === 'list' ? (
          <WorkOrderList
            hoaId={hoaId}
            homeId={homeId}
            fill
            flush
            showTitle={false}
            toolbar={switcher}
          />
        ) : (
          <WorkOrderKanbanBoard
            hoaId={hoaId}
            homeId={homeId}
            fill
            flush
            toolbar={switcher}
          />
        )}
      </div>
    </SidebarLayout>
  );
};

export default WorkOrderPage;
